export default "__VITE_ASSET__BXYWPaoa__"